import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260408_remove_empty_settings_sets",
  description: "Delete empty settings sets and empty settings set groups",
  apply(json: any) {
    if (!json.settingsSets || !json.settings || !json.groups || !json.entityRefs || !json.entityGroups) {
      return json;
    }

    const settingsTable: Record<string, any> = json.settings;
    const settingsSets: Record<string, any> = json.settingsSets;
    const entityGroups: Record<string, string> = json.entityGroups;

    // Find all nonempty settings sets.
    const nonemptySettingsSetIds = new Set<string>();
    for (const setting of Object.values(settingsTable)) {
      if (setting?.parentId) {
        nonemptySettingsSetIds.add(setting.parentId);
      }
    }

    const settingsSetGroups = new Set<string>();
    for (const [hash, groupId] of Object.entries(entityGroups)) {
      if (hash.startsWith("settingsSet.")) {
        settingsSetGroups.add(groupId);
      }
    }

    // Delete empty settings sets and their entityGroups entries.
    for (const settingsSetId of Object.keys(settingsSets)) {
      if (!nonemptySettingsSetIds.has(settingsSetId)) {
        delete json.settingsSets?.[settingsSetId];
        delete json.entityRefs?.[settingsSetId];

        const hash = `settingsSet.${settingsSetId}`;
        delete json.entityGroups?.[hash];
      }
    }

    // Remove any settings set groups that are now empty.
    for (const groupId of Array.from(settingsSetGroups)) {
      const groupStillHasAnyMember = Object.values(json.entityGroups as Record<string, string>).some(
        (gId) => gId === groupId,
      );
      if (!groupStillHasAnyMember) {
        delete json.groups[groupId];
        delete json.entityRefs[groupId];
      }
    }

    return json;
  },
};

export default migration;
